import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { config } from '../config';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-otp-screen',
  templateUrl: './otp-screen.component.html',
  styleUrls: ['./otp-screen.component.css']
})
export class OtpScreenComponent implements OnInit {
  data: any = {};
  otpMobile: any;
  error: any;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router, private serviceURLService: serviceURLService) { }

  ngOnInit() {

  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  resendOTP() {
    this.otpMobile = localStorage.getItem('mobileNumber');
    this.serviceURLService.resendOTP(this.otpMobile, this.data).pipe(takeUntil(this.onDestroy$)).subscribe(successData => {
      this.router.navigate(['otp']);
    }, errorData => {
      console.log("Oops..!! there is some error in resend OTP");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })

  }

  verifyOTPNumber() {
    this.otpMobile = localStorage.getItem('mobileNumber');
    this.serviceURLService.verifyOTP(this.otpMobile, this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      localStorage.setItem('authToken', JSON.stringify(successData.response.authToken));
      this.router.navigate(['home']);
    }, errorData => {
      console.log("Oops..!! there is some error in OTP varification");
      if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
